import {
  IAssignedPatient,
  IDesignation,
  SERVICE_STATUS,
} from "@home-health-notify/domain";
import { useMemo } from "react";
import { calculateActivePatientsProgress } from "hhn-commons";
import ActivePatientsProgressBar from "./ActivePatientsProgressBar";
import ActivePatientProgressBreakdownItem from "./ActivePatientProgressBreakdownItem";
import { ProgressBreakdownContainer } from "./AssignedPatients.style";

const AssignedPatientsProgressDetails = ({
  department,
  patients,
}: {
  department: IDesignation;
  patients: IAssignedPatient[];
}) => {
  const calculatedProgress = useMemo(
    () => calculateActivePatientsProgress(patients, department),
    [patients, department],
  );

  return (
    <>
      <ActivePatientsProgressBar progress={calculatedProgress} />
      <ProgressBreakdownContainer>
        <ActivePatientProgressBreakdownItem
          label="Pending"
          status={SERVICE_STATUS.PENDING}
          count={calculatedProgress.pending}
        />
        <ActivePatientProgressBreakdownItem
          label="Active"
          status={SERVICE_STATUS.ACTIVE}
          count={calculatedProgress.active}
        />
        <ActivePatientProgressBreakdownItem
          label="Discharged"
          status={SERVICE_STATUS.DISCHARGED}
          count={calculatedProgress.discharged}
        />
      </ProgressBreakdownContainer>
    </>
  );
};

export default AssignedPatientsProgressDetails;
